import React, {useContext, useState, useEffect, useMemo} from 'react';
import _ from 'lodash';
import { AppContext } from '../../store/contexts/AppContext';
import { NavigationContext } from '../../store/contexts/NavigationContext';
import { GalleryAndInspiration } from '../../components';

export default function Inspiration() {
	
	const context = useContext(AppContext);
	const navContext = useContext(NavigationContext);
	const { isUserLoggedIn, cmsConfiguration, userPreferences, artCollection, personalArtCollection } = context;
	const {location} = navContext;
	const [dispatchEvent, setDistpatchEvent] = useState(false);
	const [imageId, setImageId] = useState();	
	const atmosphere = _.get(userPreferences, 'atmosphere', '');
	const inspirationLabels = _.get(cmsConfiguration, `labels.inspiration`, {})
	const assets = _.get(inspirationLabels,'assets', {});
	const user = {isUserLoggedIn, personalArtCollection};

	const {
		cool=[],
		elegant=[], 
		emotion=[],
		original=[],
		relax=[],
		lbx=[]
	} = assets;


	const images = useMemo(() => _.shuffle([
		...artCollection,
		...cool, 
		...elegant, 
		...emotion, 
		...original, 
		...relax, 
		...lbx]), [artCollection, cool, elegant, emotion, original, relax, lbx]); 

	const getImageUrlFromId = (id) => {
		const image = _.find(images, {id})
		return image ? image.base : null;
	}

	useEffect(()=> {
		const pathNameArray = _.compact(location.pathname.split('/').slice(-2));
		
		if (pathNameArray.length > 1) {
			setImageId(pathNameArray[1]);
		}

		setDistpatchEvent(true);
	}, [location.pathname]);
	
	useEffect(() => {
		if (dispatchEvent){
			let activeImageUrl;
			
			if (imageId) {
				activeImageUrl = getImageUrlFromId(imageId);
			}
			
			window.dispatchEvent(
				new CustomEvent('trigger-open-gallery-and-inspiration-overlay', { detail: { overlayId: 'lbx-image-gallery', activeImageUrl, imageId }})); 
			}
		},[dispatchEvent])
		
	return ( 
		<GalleryAndInspiration {...{
		...inspirationLabels,
		atmosphere,
		images, 
		user
		}}/>
	)
}